export default "__VITE_ASSET__ytRKWy4r__"